import { Pullout, PulloutType } from '@aon/aon-tws-common-ui';
import React from 'react';
import styled from 'styled-components';

const PulloutContainer = styled.div`
	margin: auto;
	margin-bottom: 30px;
	width: 50%;
`;
PulloutContainer.displayName = 'PulloutContainer';

export const AudienceDuplicatesPullout = () => {
	return (
		<>
			<PulloutContainer>
				<Pullout type={PulloutType.Note}>
					Duplicate employee IDs will be removed from distribution upon publish so that an employee does not receive two survey email links.
					Expect changes to your employee count if this occurs.
				</Pullout>
			</PulloutContainer>
		</>
	);
};
